import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = { open: Boolean }

  openValueChanged() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()

    if (this.hasTriggerTarget || this.hasPanelTarget) {
      this.openValue = !this.openValue
      return
    }

    const section = event.currentTarget
    const expanded = section.getAttribute("aria-expanded") === "true"
    section.setAttribute("aria-expanded", String(!expanded))
  }

  toggleAll(event) {
    const expanded = event.currentTarget.dataset.expanded === "true"

    this.element.querySelectorAll(".accordeon-section").forEach((section) => {
      section.setAttribute("aria-expanded", String(expanded))
    })
  }

  render() {
    const expanded = this.openValue

    this.element.dataset.expanded = String(expanded)

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", String(expanded))
    }

    if (this.hasPanelTarget) {
      this.panelTarget.hidden = !expanded
    }
  }
}
